// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"80e270fe","447":"80e270fe","938":"80e270fe","961":"80e270fe"}[chunkId] + ".chunk.css";
};